import { useDisclosure } from "@heroui/react";
import { InputField, ModalBuilder, ModalError } from "../modalBuilder";
import { api } from "@/api";
import { toast } from "react-toastify";
import useErrorHandling from "@/hooks/useErrorHandling";
import { useState } from "react";
import { useAppSelector } from "@/hooks/useAppSelector";

interface ICreateSigurIntegrationForm {
  name: string;
  location_id: number;
  credentials_id: number;
}

const createSigurIntegrationFields: InputField[] = [
  {
    label: "Название интеграции",
    name: "name",
    placeholder: "Сигур интеграция",
    type: "text",
    isRequired: true,
  },
  {
    label: "Локация",
    name: "location_id",
    placeholder: "",
    type: "location",
    isRequired: true,
  },
  {
    label: "Система замков",
    name: "credentials_id",
    placeholder: "",
    type: "lock-system",
    isRequired: true,
  },
];

export function CreateSigurIntegrationModal({
  disclosure,
}: {
  disclosure: ReturnType<typeof useDisclosure>;
}) {
  const { isOpen, onOpenChange } = disclosure;
  const [modalErrors, setModalErros] = useState<ModalError[]>([]);
  const businessProfileId = useAppSelector(
    (state) => state.businessProfile.businessProfile.id,
  );

  const handleError = useErrorHandling();

  const onSubmit = (data: ICreateSigurIntegrationForm) => {
    return new Promise<boolean>(async (resolve, _reject) => {
      api.sigur
        .create({
          name: data.name,
          location_id: data.location_id,
          credentials_id: Number(data.credentials_id),
          owner_id: businessProfileId,
        })
        .then((_data) => {
          toast.success("Интеграция с Сигуром успешно создана");
          disclosure.onClose();
          resolve(true);
        })
        .catch((err) => {
          console.log(err);
          const { errorMessage, parsedErrors } = handleError(err);
          setModalErros(parsedErrors || []);
          toast.error(errorMessage);
          resolve(false);
        });
    });
  };

  return (
    <ModalBuilder
      title="Создание интеграции с Сигуром"
      modalErrors={modalErrors}
      fields={createSigurIntegrationFields}
      isOpen={isOpen}
      isSensitiveData={false}
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
}
